import { render, staticRenderFns } from "./groupPackage.vue?vue&type=template&id=fe4b4014&"
import script from "./groupPackage.vue?vue&type=script&lang=js&"
export * from "./groupPackage.vue?vue&type=script&lang=js&"
import style0 from "./groupPackage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports